import React from "react";
import groupMLogo from "../assets/icons/GroupMNexusLogo.png";
import { createStyles, Theme, makeStyles } from "@material-ui/core/styles";
import style from "./style";
import moment from "moment";
import * as _ from "lodash";
const useStyles = makeStyles((theme: Theme) => createStyles(style(theme)));
type props = {
  info: any;
};
const MaintenancePortal = (props:props) : React.JSX.Element =>{
    const classes = useStyles();
    const maintenanceInfo:any = props.info[0];
    const convertDate = (date: any, enddate: boolean): any => {
        const isoUtc = moment.utc(
            date,
            "YYYY-MM-DD hh:mm A [(UTC)]"
        ).format("YYYY-MM-DD[T]HH:mm:ss[Z]");
        // converting to local time via userlocation
        const formatted = moment(new Date(isoUtc))
            .format(enddate ? "hh:mm A" : "dddd, DD MMMM YYYY");
        return formatted;
    };

    const formatter = new Intl.DateTimeFormat("en-US", {
        timeZoneName: "long"
    });
    const parts = formatter.formatToParts(new Date());
    const tzName = parts.find(p => p.type === "timeZoneName")?.value;

    return (
            <div className={classes.maintenancePage}>
                <div className={classes.maintenancePageContainer}>
                    <img alt="GroupM" src={groupMLogo} width="200" height="40" style={{ paddingRight: "40px" }} />
                    <div className={classes.maintenancePageHeading}>Scheduled Maintenance in Progress.</div>
                    {!_.isEmpty(maintenanceInfo) && <><div className={classes.maintenancePageContent}>
                        Our portal will be temporarily unavailable until <strong>{convertDate(maintenanceInfo?.enddate, true)} ({tzName})</strong> on <strong>{convertDate(maintenanceInfo.enddate, false)}.</strong>
                    </div>
                        <div className={classes.maintenancePageContent}>
                            Thank you for your patience as we perform scheduled maintenance.
                        </div>
                    </>}
                </div>
            </div>
    );
};

export default MaintenancePortal;